import ControlArea from "components/Layout/ControlArea";
import React, { useEffect } from "react";
import Table from "./Table";
import adminsIcon from "assets/svgs/admins.svg";

import { useDispatch } from "react-redux";
import { getAdmins } from "store/actions";
const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAdmins());
  }, [dispatch]);

  return (
    <>
      <div className="users-wrap">
        <ControlArea
          btnTxt="اضافة مشرف"
          cardTxt="المشرفين"
          icon={adminsIcon}
          url="/admins/add"
        />
        <Table />
      </div>
    </>
  );
};

export default Index;
